// cbAdminFix.ts
// Utility to replace all occurrences of 'Cannonball General Admin' with 'CB Admin' across the site.

/**
 * Replaces all occurrences of 'Cannonball General Admin' with 'CB Admin' in a string.
 * Returns the original value if not a string.
 * @param val The value to transform
 */
export function cbAdminFix(val: string): string {
  return typeof val === 'string'
    ? val.replace(/Cannonball General Admin/g, 'CB Admin')
    : val;
}
